"use client";

import { MouseEvent } from "react";
import IconCheckCircle from "@/app/(components)/generics/Icons/IconCheckCircle";
import IconDangerTriangle from "@/app/(components)/generics/Icons/IconDangerTriangle";
import { Tooltip, TooltipPosition, TooltipType } from "@/app/(components)/generics/Tootlip/Tooltip";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { UStyles } from "@/app/utils/UStyles";
import styles from "./AvatarFreshnessBadge.module.css";

type Props = {
  isStale: boolean;
  onEnrich?: () => void;
};

export default function AvatarFreshnessBadge(props: Props) {
  const T = useT();
  const { isStale, onEnrich } = props;

  const clickable = isStale && !!onEnrich;

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
    if (clickable && onEnrich) {
      onEnrich();
    }
  };

  return (
    <Tooltip
      position={TooltipPosition.LEFT}
      gap={6}
      type={TooltipType.NONE}
      portal={true}
      className={isStale ? styles.tooltipStale : styles.tooltipFresh}
      trigger={
        <span
          className={UStyles.classNames(
            styles.badge,
            isStale ? styles.stale : styles.fresh,
            clickable && styles.clickable,
          )}
          onClick={handleClick}
        >
          {isStale ? <IconDangerTriangle size={16} /> : <IconCheckCircle size={16} />}
        </span>
      }
      content={T(isStale ? TKey.CLIENT_AVATAR_FRESHNESS_STALE : TKey.CLIENT_AVATAR_FRESHNESS_FRESH)}
    />
  );
}
